import { Surface } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Button from "../Button";
import Container from "../Container";

type Props = {
	label: string;
	onPress: () => void;
	maxWidth?: "xxs" | "xs" | "sm" | "md" | "lg";
	paddingTop?: number;
	paddingBottom?: number;
};

export const ScreenBottomActionBar = ({
	label,
	onPress,
	maxWidth = "sm",
	paddingTop = 16,
	paddingBottom = 12,
}: Props) => {
	const insets = useSafeAreaInsets();

	return (
		<Surface
			style={{
				paddingBottom: Math.max(insets.bottom, paddingBottom),
				paddingTop,
			}}
		>
			<Container maxWidth={maxWidth} padding autoSize>
				<Button mode="contained" onPress={onPress}>
					{label}
				</Button>
			</Container>
		</Surface>
	);
};
